// POST /api/jobs/pay-cycle/run
export type PayCycleStage =
  | 'all'
  | 'timesheets'
  | 'invoices'
  | 'payouts'
  | 'process-payments';

export interface RunPayCycleParams {
  stage?: PayCycleStage;
  facilityId?: string;
  bypassInvoiceOffsetDays?: boolean;
  bypassTimeZoneValidation?: boolean;
  periodStartDate?: string; // DateOnly (yyyy-MM-dd)
  periodEndDate?: string; // DateOnly (yyyy-MM-dd)
}

export interface RunPayCycleResult {
  ranStages: string[];
  facilityId: string | null;
  bypassInvoiceOffsetDays: boolean;
  bypassTimeZoneValidation: boolean;
  periodStartDate: string | null;
  periodEndDate: string | null;
  facilityFilterNotAppliedTo: string[];
}
